import api from '@/services/api'
import bff from '@/services/bff'
import reportApi from '@/services/reportApi'
import produce from 'immer'
import { ACTIONS } from './actions'

const INITIAL_STATE = {
  signed: false,
  token: null,
  user: null,
  loading: false,
  failure: null,
  actionSuccess: false,
}

export default function auth(state = INITIAL_STATE, action) {
  const { type, payload } = action

  return produce(state, (draft) => {
    switch (type) {
      case ACTIONS.SIGN_IN_REQUEST: {
        draft.loading = true
        break
      }

      case ACTIONS.SIGN_IN_REQUEST_SUCCESS: {
        draft.signed = true
        draft.token = payload.token
        draft.user = payload.user
        draft.refresh = payload.refresh
        draft.failure = false
        draft.loading = false
        break
      }

      case ACTIONS.SIGN_IN_REQUEST_FAILURE: {
        draft.loading = false
        draft.failure = payload.data
        break
      }

      case ACTIONS.SIGN_IN_REJECTION: {
        draft.failure = { data: { errors: [{ mensagem: 'Usuário ou Senha incorretos', type: 2 }] } }
        draft.loading = false
        break
      }

      case ACTIONS.SIGN_OUT_REQUEST: {
        draft.signed = false
        draft.token = null
        draft.user = null
        draft.failure = false
        break
      }

      case ACTIONS.PASSWORD_RESET_REQUEST: {
        draft.loading = true
        break
      }

      case ACTIONS.ACTION_REQUEST_SUCCESS: {
        draft.loading = false
        draft.actionSuccess = payload.data
        break
      }

      case ACTIONS.ACTION_REQUEST_FAILURE: {
        draft.loading = false
        draft.failure = payload.data
        break
      }

      case '@auth/SIGN_OUT': {
        draft.signed = false
        draft.token = null
        draft.failure = false
        api.defaults.headers.common.Authorization = null
        bff.defaults.headers.common.Authorization = null
        reportApi.defaults.headers.common.Authorization = null
        break
      }

      default:
    }
  })
}
